var React = require('react');

function SocialIconYoutube (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M24.2261 2.97089C23.9493 1.79934 23.1364 0.879898 22.1038 0.568473C20.232 0 12.7271 0 12.7271 0C12.7271 0 5.22211 0 3.35027 0.568473C2.31768 0.879898 1.50479 1.79934 1.22797 2.97089C0.727051 5.09154 0.727051 9.5108 0.727051 9.5108C0.727051 9.5108 0.727051 13.9301 1.22797 16.0507C1.50479 17.2223 2.31768 18.1022 3.35027 18.4136C5.22211 18.9821 12.7271 18.9821 12.7271 18.9821C12.7271 18.9821 20.232 18.9821 22.1038 18.4136C23.1364 18.1022 23.9493 17.2173 24.2261 16.0507C24.7271 13.9301 24.7271 9.5108 24.7271 9.5108C24.7271 9.5108 24.7271 5.09154 24.2261 2.97089ZM10.2752 13.5247V5.49689L16.5454 9.5108L10.2752 13.5247Z","fill":"black"}));
}

SocialIconYoutube.defaultProps = {"width":"25","height":"19","viewBox":"0 0 25 19","fill":"none"};

module.exports = SocialIconYoutube;

SocialIconYoutube.default = SocialIconYoutube;
